const AUTH_BASE_URL = process.env.VUE_APP_AUTH_BASE_URL;
const BASE_URL = process.env.VUE_APP_AUDIT_BASE_URL;

export default {
	getServerHost() {
		return BASE_URL;
	},

	getAuthBaseUrl() {
		return AUTH_BASE_URL;
	},

	getLoginLink() {
		return `${this.getAuthBaseUrl()}/login/?redirect_url=${this.getServerHost()}/validation`;
	},
};
